import { IChoiceGroupOption, IChoiceGroupStyles, IDropdownStyles, IIconProps, ITooltipHostStyles } from "office-ui-fabric-react";
import SettingService from "../../../services/SettingService";
import moment from "moment";

export const dropdownStyles: Partial<IDropdownStyles> = {
    dropdownItemsWrapper: {
      maxHeight: "180px",
    },
  };


export const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "inline-block" },
  };

export const Delete: IIconProps = { iconName: "Cancel" };

export const onFormatDate = (date?: Date): string => {
    var date1 = !date
      ? ""
      : date.getMonth() + 1 + "-" + date.getDate() + "-" + date.getFullYear();
    let dateFormat = SettingService.GetDateformat();
    // const dateFormat = dateFormat1;
    const dateString = date.toString();
    if (dateString !== "Invalid Date")
      return moment(dateString).format(dateFormat);
  };

  export  const choiceGroupStyles: IChoiceGroupStyles = {
    root: {
      flex: "0 1 25%",
      "label::after": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
      "label:hover::after": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
      "label::before": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
      "label:hover::before": {
        borderColor:
          SettingService.GetTheme() == "light"
            ? "var(--lightdarkColor) !important"
            : "var(--lightdarkBGGray) !important",
      },
    },
    flexContainer: {
      display: "flex",
      justifyContent: "initial",
      width: "100%",
      // columnGap: '50px',
    },
  };

  export   const counterpartyoption: IChoiceGroupOption[] = [
    { key: "Definite", text: "Definite" },
    { key: "Indefinite", text: "Indefinite" },
  ];

  export const paymentTermsOptions= [
  {
    key: 'One Time',
    value: 'One Time',
    text: 'One Time',
    label: 'One Time'
  },
  {
    key: 'Monthly',
    value: 'Monthly',
    text: 'Monthly',
    label: 'Monthly'
  },
  {
    key: 'Quarterly',
    value: 'Quarterly',
    text: 'Quarterly',
    label: 'Quarterly'
  },
  {
    key: 'Half Yearly',
    value: 'Half Yearly',
    text: 'Half Yearly',
    label: 'Half Yearly'
  },
  {
    key: 'Yearly',
    value: 'Yearly',
    text: 'Yearly',
    label: 'Yearly'
  }
];

export const currecncyOptions: any = [
  {
    key: "USD_$",
    label: "USD",
    text: "USD",
    value: "USD",
  },
  {
    key: "GBP_£",
    label: "GBP",
    text: "GBP",
    value: "GBP",
  },
  {
    key: "CAD_$",
    label: "CAD",
    text: "CAD",
    value: "CAD",
  },
  {
    key: "€",
    label: "EUR",
    text: "EUR",
    value: "EUR",
  },
  {
    key: "AUD_$",
    label: "AUD",
    text: "AUD",
    value: "AUD",
  },
  {
    key: "NZD_$",
    label: "NZD",
    text: "NZD",
    value: "NZD",
  },
  {
    key: "SGD_$",
    label: "SGD",
    text: "SGD",
    value: "SGD",
  },
  {
    key: "₹",
    label: "INR",
    text: "INR",
    value: "INR",
  },
  {
    key: "؋",
    label: "AFN",
    text: "AFN",
    value: "AFN",
  },
  {
    key: "ANG_Naf",
    label: "ANG",
    text: "ANG",
    value: "ANG",
  },
  {
    key: "ARS_$",
    label: "ARS",
    text: "ARS",
    value: "ARS",
  },
  {
    key: "ƒ",
    label: "AWG",
    text: "AWG",
    value: "AWG",
  },
  {
    key: "₼",
    label: "AZN",
    text: "AZN",
    value: "AZN",
  },
  {
    key: "BSD_$",
    label: "BSD",
    text: "BSD",
    value: "BSD",
  },
  {
    key: "BBD_$",
    label: "BBD",
    text: "BBD",
    value: "BBD",
  },
  {
    key: "Br",
    label: "BYN",
    text: "BYN",
    value: "BYN",
  },
  {
    key: "BZ$",
    label: "BZD",
    text: "BZD",
    value: "BZD",
  },
  {
    key: "$b",
    label: "BOB",
    text: "BOB",
    value: "BOB",
  },
  {
    key: "KM",
    label: "BAM",
    text: "BAM",
    value: "BAM",
  },
  {
    key: "P",
    label: "BWP",
    text: "BWP",
    value: "BWP",
  },
  {
    key: "BGN_лв",
    label: "BGN",
    text: "BGN",
    value: "BGN",
  },
  {
    key: "R$",
    label: "BRL",
    text: "BRL",
    value: "BRL",
  },
  {
    key: "BND_$",
    label: "BND",
    text: "BND",
    value: "BND",
  },
  {
    key: "CLP_$",
    label: "CLP",
    text: "CLP",
    value: "CLP",
  },
  {
    key: "CNY_¥",
    label: "CNY",
    text: "CNY",
    value: "CNY",
  },
  {
    key: "COP_$",
    label: "COP",
    text: "COP",
    value: "COP",
  },
  {
    key: "₡",
    label: "CRC",
    text: "CRC",
    value: "CRC",
  },
  {
    key: "kn",
    label: "HRK",
    text: "HRK",
    value: "HRK",
  },
  {
    key: "CUP_₱",
    label: "CUP",
    text: "CUP",
    value: "CUP",
  },
  {
    key: "Kč",
    label: "CZK",
    text: "CZK",
    value: "CZK",
  },
  {
    key: "DKK_kr",
    label: "DKK",
    text: "DKK",
    value: "DKK",
  },
  {
    key: "RD$",
    label: "DOP",
    text: "DOP",
    value: "DOP",
  },
  {
    key: "XCD_$",
    label: "XCD",
    text: "XCD",
    value: "XCD",
  },
  {
    key: "EGP_£",
    label: "EGP",
    text: "EGP",
    value: "EGP",
  },
  {
    key: "SVC_$",
    label: "SVC",
    text: "SVC",
    value: "SVC",
  },

  {
    key: "FKP_£",
    label: "FKP",
    text: "FKP",
    value: "FKP",
  },
  {
    key: "FJD_$",
    label: "FJD",
    text: "FJD",
    value: "FJD",
  },
  {
    key: "¢",
    label: "GHS",
    text: "GHS",
    value: "GHS",
  },
  {
    key: "GIP_£",
    label: "GIP",
    text: "GIP",
    value: "GIP",
  },
  {
    key: "D",
    label: "GMD",
    text: "GMD",
    value: "GMD",
  },
  {
    key: "Q",
    label: "GTQ",
    text: "GTQ",
    value: "GTQ",
  },
  {
    key: "GGP_£",
    label: "GGP",
    text: "GGP",
    value: "GGP",
  },
  {
    key: "GYD_$",
    label: "GYD",
    text: "GYD",
    value: "GYD",
  },
  {
    key: "L",
    label: "HNL",
    text: "HNL",
    value: "HNL",
  },
  {
    key: "HKD_$",
    label: "HKD",
    text: "HKD",
    value: "HKD",
  },
  {
    key: "Ft",
    label: "HUF",
    text: "HUF",
    value: "HUF",
  },
  {
    key: "ISK_kr",
    label: "ISK",
    text: "ISK",
    value: "ISK",
  },
  {
    key: "Rp",
    label: "IDR",
    text: "IDR",
    value: "IDR",
  },
  {
    key: "IRR_﷼",
    label: "IRR",
    text: "IRR",
    value: "IRR",
  },
  {
    key: "IMP_£",
    label: "IMP",
    text: "IMP",
    value: "IMP",
  },
  {
    key: "JEP_£",
    label: "JEP",
    text: "JEP",
    value: "JEP",
  },
  {
    key: "៛ ",
    label: "KHR",
    text: "KHR",
    value: "KHR",
  },
  {
    key: "KYD_$",
    label: "KYD",
    text: "KYD",
    value: "KYD",
  },
  {
    key: "﷼лв",
    label: "KZT",
    text: "KZT",
    value: "KZT",
  },
  {
    key: "KPW_₩",
    label: "KPW",
    text: "KPW",
    value: "KPW",
  },
  {
    key: "KGS_лв",
    label: "KGS",
    text: "KGS",
    value: "KGS",
  },
  {
    key: "₭",
    label: "LAK",
    text: "LAK",
    value: "LAK",
  },
  {
    key: "LBP_£",
    label: "LBP",
    text: "LBP",
    value: "LBP",
  },
  {
    key: "LRD_$",
    label: "LRD",
    text: "LRD",
    value: "LRD",
  },
  {
    key: "ден",
    label: "MKD",
    text: "MKD",
    value: "MKD",
  },
  {
    key: "RM",
    label: "MYR",
    text: "MYR",
    value: "MYR",
  },
  {
    key: "MUR_₨",
    label: "MUR",
    text: "MUR",
    value: "MUR",
  },
  {
    key: "MXN_$",
    label: "MXN",
    text: "MXN",
    value: "MXN",
  },
  {
    key: "₮",
    label: "MNT",
    text: "MNT",
    value: "MNT",
  },
  {
    key: "MT",
    label: "MZN",
    text: "MZN",
    value: "MZN",
  },
  {
    key: "NAD_$",
    label: "NAD",
    text: "NAD",
    value: "NAD",
  },
  {
    key: "NAFL_Naf",
    label: "NAFL",
    text: "NAFL",
    value: "NAFL",
  },
  {
    key: "NPR_₨",
    label: "NPR",
    text: "NPR",
    value: "NPR",
  },
  {
    key: "C$",
    label: "NIO",
    text: "NIO",
    value: "NIO",
  },
  {
    key: "NOK_kr",
    label: "NOK",
    text: "NOK",
    value: "NOK",
  },
  {
    key: "OMR_﷼",
    label: "OMR",
    text: "OMR",
    value: "OMR",
  },
  {
    key: "PKR_₨",
    label: "PKR",
    text: "PKR",
    value: "PKR",
  },
  {
    key: "B/.",
    label: "PAB",
    text: "PAB",
    value: "PAB",
  },
  {
    key: "Gs",
    label: "PYG",
    text: "PYG",
    value: "PYG",
  },
  {
    key: "S/.",
    label: "PEN",
    text: "PEN",
    value: "PEN",
  },
  {
    key: "zł",
    label: "PLN",
    text: "PLN",
    value: "PLN",
  },
  {
    key: "QAR_﷼",
    label: "QAR",
    text: "QAR",
    value: "QAR",
  },
  {
    key: "lei",
    label: "RON",
    text: "RON",
    value: "RON",
  },
  {
    key: "₽",
    label: "RUB",
    text: "RUB",
    value: "RUB",
  },
  {
    key: "SHP_£",
    label: "SHP",
    text: "SHP",
    value: "SHP",
  },
  {
    key: "SAR_﷼",
    label: "SAR",
    text: "SAR",
    value: "SAR",
  },
  {
    key: "Дин.",
    label: "RSD",
    text: "RSD",
    value: "RSD",
  },
  {
    key: "SCR_₨",
    label: "SCR",
    text: "SCR",
    value: "SCR",
  },
  {
    key: "SBD_$",
    label: "SBD",
    text: "SBD",
    value: "SBD",
  },
  {
    key: "SOSS",
    label: "SOS",
    text: "SOS",
    value: "SOS",
  },
  {
    key: "R",
    label: "ZAR",
    text: "ZAR",
    value: "ZAR",
  },
  {
    key: "LKR_₨",
    label: "LKR",
    text: "LKR",
    value: "LKR",
  },
  {
    key: "SEK_kr",
    label: "SEK",
    text: "SEK",
    value: "SEK",
  },
  {
    key: "CHF",
    label: "CHF",
    text: "CHF",
    value: "CHF",
  },
  {
    key: "SRD_$",
    label: "SRD",
    text: "SRD",
    value: "SRD",
  },
  {
    key: "SYP_£",
    label: "SYP",
    text: "SYP",
    value: "SYP",
  },
  {
    key: "NT$",
    label: "TWD",
    text: "TWD",
    value: "TWD",
  },
  {
    key: "฿",
    label: "THB",
    text: "THB",
    value: "THB",
  },
  {
    key: "VND_₫",
    label: "VND",
    text: "VND",
    value: "VND",
  },
  {
    key: "₪",
    label: "ILS",
    text: "ILS",
    value: "ILS",
  },
  {
    key: "JPY_¥",
    label: "JPY",
    text: "JPY",
    value: "JPY",
  },
  {
    key: "KRW_₩",
    label: "KRW",
    text: "KRW",
    value: "KRW",
  },
  {
    key: "₦",
    label: "NGN",
    text: "NGN",
    value: "NGN",
  },
  {
    key: "PHP_₱",
    label: "PHP",
    text: "PHP",
    value: "PHP",
  },
  {
    key: "TT$",
    label: "TTD",
    text: "TTD",
    value: "TTD",
  },
  {
    key: "₺",
    label: "TRY",
    text: "TRY",
    value: "TRY",
  },
  {
    key: "TVD_$",
    label: "TVD",
    text: "TVD",
    value: "TVD",
  },
  {
    key: "₴",
    label: "UAH",
    text: "UAH",
    value: "UAH",
  },
  {
    key: "$U",
    label: "UYU",
    text: "UYU",
    value: "UYU",
  },
  {
    key: "UZS_лв",
    label: "UZS",
    text: "UZS",
    value: "UZS",
  },
  {
    key: "Bs",
    label: "VEF",
    text: "VEF",
    value: "VEF",
  },
  {
    key: "YER_﷼",
    label: "YER",
    text: "YER",
    value: "YER",
  },
  {
    key: "Z$",
    label: "ZWD",
    text: "ZWD",
    value: "ZWD",
  },
  {
    key: "T$",
    label: "TOP",
    text: "TOP",
    value: "TOP",
  },
  {
    key: "MVR_ރ",
    label: "MVR",
    text: "MVR",
    value: "MVR",
  },
];